<template>

    <appStartModal
        ref="appStartModel"
        :appName="selectedAppName"
        @job_started="jobStartedHandler"
    />

  <div v-if="apps" class="apps-list">
        <AppCard v-for="app in apps" :key="app.name" 
            :params="app"
            @app_selected="jobSelectedHandler"
        />
    </div>

    <div v-else >
        <h2>No Apps Available</h2>
    </div>


</template>

<script setup>
import {ref, defineEmits,onMounted} from 'vue';

import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import AppCard from '@/components/Apps/AppCard.vue';
import appStartModal from '@/components/Apps/AppStartModal.vue';

import { useStore } from 'vuex';
const store = useStore();

const $toast = useToast();
const emit = defineEmits(['job_started']);
const appStartModel = ref(null)
const selectedAppName = ref('')
const loading = ref(false);
const apps = ref(null);

const dataConnect = new DatastoreConnect();

 onMounted(async () => {
  dataConnect.api('app.list',{})
  .then((ret) => {
    if(ret.result){
    apps.value=ret.result;
  }
  if(ret.error){
    const $toast = useToast();
          $toast.open({
            queue: true,
            duration: 5000,
            message: ret.error.message,
            type: 'error',
            position: 'top',
          });
        }
  })
   .catch((error) => {
      console.log(error);
      return '';
    });     
});

function jobStartedHandler(params) {
 emit('job_started');
}

function jobSelectedHandler(name) {
    selectedAppName.value=name;
    appStartModel.value.showModal();
}

</script>

<style lang="scss" scoped>

.apps-list {
    padding: 10px;
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;

}

</style>
